export default __webpack_public_path__ + "static/media/project_shot_east_douglas_0.d32b6ecf.jpg";